import { useWindowDimensions } from 'react-native';

import { SCROLLBAR_WIDTH } from '@/feature/responsive-design/WebComponents';

export const RIPS_ROW_PADDING = 16;
const RIPS_ROW_PEEK = 16;
// width cap so the cards don't become too large on wide screens or web
export const RIPS_MAX_ROW_WIDTH = 500;

/** Width of a horizontally scrolling Rips row item, sized so two items fit and the third peeks 16px past the edge. */
export const useRipsRowItemWidth = (gap: number) => {
    const { width } = useWindowDimensions();
    const rowWidth = Math.min(width - SCROLLBAR_WIDTH, RIPS_MAX_ROW_WIDTH);

    return Math.floor((rowWidth - RIPS_ROW_PADDING - RIPS_ROW_PEEK - 2 * gap) / 2);
};
